<template>
  <div>
    <common-dialog ref="dialog" show-save-button width="850px" unit="模拟器" edit-title id-key="CoopId"
      :data="data" form-label-width="100px" :form-rules="rules" :save-func="api.save" :get-data-func="api.info"
      close-on-saved @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed"
      :before-save="onBeforeSave" @details-opened="onDetailsOpened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属机构" prop="DpId">
              <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="data.DpId"
                :clearable="true" :accordion="true" :parentSelect="true" placeholder="请选择"
                @node-select="onTreeSelect($event)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模拟器编号" prop="SimulatorNo">
              <el-input v-model="data.SimulatorNo" placeholder="请填写模拟器编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模拟器品牌" prop="SimulatorBrand">
              <el-select v-model="data.SimulatorBrand">
                <el-option v-for="item in brandList" :key="item.DataId" :value="item.DataName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模拟器类型" prop="SimulatorType">
              <el-select v-model="data.SimulatorType">
                <el-option v-for="item in typeList" :key="item.DataId" :value="item.DataName" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模拟器型号" prop="SimulatorModel">
              <el-select v-model="data.SimulatorModel">
                <el-option v-for="item in modelList" :key="item.DataId" :value="item.DataName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产厂家" prop="Manufactor">
              <el-select v-model="data.Manufactor">
                <el-option v-for="item in factorList" :key="item.DataId" :value="item.DataName" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="培训车型" prop="CarTypes">
              <el-select v-model="CarTypes" multiple @change="mulChange('CarTypes')">
                <el-option v-for="item in carTypeList" :key="item.DataId" :value="item.DataName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="loginInfo.UserType!=1">
            <el-form-item label="入库日期" prop="InDate">
              <el-date-picker v-model.trim="data.InDate" type="date" value-format="yyyy-MM-dd" placeholder="选择时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度" prop="GpsLng">
              <el-input v-model="data.GpsLng" type="number" placeholder="请填写经度"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="GpsLat">
              <el-input v-model="data.GpsLat" type="number" placeholder="请填写纬度"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片" prop="PicUrls" class="is-required">
              <div>
                <el-upload class="file-up" :action="host + '/api/Common/UploadPicture'" list-type="picture-card"
                  :show-file-list="true" accept=".jpg,.png,.jpeg"
                  :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'PicUrls') }" :headers="headers" :file-list="PicUrls"
                  :on-preview="handlePictureCardPreview" :on-exceed="onExceed" :before-upload="beforePhotoUpload"
                  :on-remove="($event) => { picRemove($event,'PicUrls') }">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
  var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/simulator";
  import treeSelect from "@/components/common/treeSelect";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      treeSelect,
    },
    data() {
      return {
        data: {
          SimulatorId: 0,
          SimulatorNo: null,
          SimulatorBrand: null,
          SimulatorType: null,
          SimulatorModel: null,
          Manufactor: null,
          CarTypes: [],
          InDate: null,
          PicUrls: "",
          Remark: null,
          DpId: null,
          DpName: "",
          GpsLng: null,
          GpsLat: null,
        },
        defaultProps: {
          children: 'children',
          label: 'DpName'
        },
        loginInfo,
        api,
        dpApi: require("@/api/basic/dp").default,
        basicApi: require("@/api/basic/data").default,
        rules: {
          DpId: [{ required: true, message: "请选择归属机构" }],
          SimulatorNo: [{ required: true, message: "请填写模拟器编号" }],
          SimulatorBrand: [{ required: true, message: "请选择模拟器品牌" }],
          SimulatorType: [{ required: true, message: "请选择模拟器类型" }],
          SimulatorModel: [{ required: true, message: "请选择模拟器型号" }],
          Manufactor: [{ required: true, message: "请选择生产厂家" }],
          CarTypes: [{ required: true, message: "请选择培训车型" }],
          InDate: [{ required: true, message: "请选择入库日期" }],
          GpsLng: [{ required: true, message: "请填写经度" }],
          GpsLat: [{ required: true, message: "请填写纬度" }],
        },
        CarTypes: [],
        PicUrls: [],
        dialogImageUrl: "",
        dialogVisible: false,
        TreeData: [],
        brandList: [],//品牌
        typeList: [],//类型
        modelList: [],//型号
        factorList: [],//生产厂家
        carTypeList: [],//车型
        headers: { Authorization: "" },
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
      };
    },
    computed: {
      host() {
        return window.location.origin;
      }
    },
    methods: {
      onCreateOpened() {
        this.readonly = false;
        this.GetBaseData();
        this.getTreeData(true);
      },
      onEditOpened(data) {
        this.GetBaseData();
        var parr = data.PicUrls.split(",");
        this.CarTypes = data.CarTypes.split(",");
        parr.forEach(n => {
          this["PicUrls"].push({ url: '/api' + n, url2: n });
        })
        this.getTreeData();
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      getTreeData() {
        this.dpApi.getAuthList({ DpTypes: [2,3], Status: 3, NoReturnParent: true }).then((res) => {
          this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
          if (this.data.DpId) {
            this.$refs.treeSelect.setData(this.data.DpId);
          }
        });
      },
      GetBaseData() {
        this.basicApi.list({ ClassName: "模拟器品牌", Status: 1 }).then(res => {
          this.brandList = res.Data
        });
        this.basicApi.list({ ClassName: "模拟器类型", Status: 1 }).then(res => {
          this.typeList = res.Data
        });
        this.basicApi.list({ ClassName: "模拟器型号", Status: 1 }).then(res => {
          this.modelList = res.Data
        });
        this.basicApi.list({ ClassName: "模拟器厂家", Status: 1 }).then(res => {
          this.factorList = res.Data
        });
        this.basicApi.list({ ClassName: "培训车型", Status: 1 }).then(res => {
          this.carTypeList = res.Data
        });
      },
      onTreeSelect(t) {
        if (!t) {
          this.data.DpId = 0;
        } else {
          this.data.DpId = t.DpId;
        }
      },
      beforePhotoUpload(file) {
        this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      },
      onExceed() {
        this.$message.error("只能上传一张图片");
      },
      onSuccess(res,file,fileList, name) {
        if (res.Code == 0) {
          this[name].push({ url: "/api" + res.Data, url2: res.Data })
        } else {
          fileList.splice(fileList.length-1,1);
          this.$message.error(res.Msg);
        }
      },
      picRemove(file, name) {
        this[name].forEach((e, i) => {
          if (e.url == file.url) {
            this[name].splice(i, 1);
            return;
          }
        })
      },
      mulChange(v) {
        this.data[v] = this[v].join(",");
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      onBeforeSave() {
        if (this.PicUrls.length == 0) {
          this.$message.error("请上传图片");
          return false;
        }
        var urlArr = ["PicUrls"];
        urlArr.forEach(e => {
          this.data[e] = "";
          this[e].forEach((n, i) => {
            this.data[e] += n.url2;
            if (i < this[e].length - 1) {
              this.data[e] += ",";
            }
          });
        })
      },
      onClosed() {
        this.TreeData = [];
        this.TreeData2 = [];
        this.CarTypes = [];
        this.PicUrls = [];
        this.$refs.treeSelect.clearHandle();
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>